// SegurIA — nombres en espanol de los marcos de amenazas (MITRE ATT&CK, ATLAS, OWASP LLM).
// Los identificadores canonicos (T1190, AML.T0051.000, LLM01) no se traducen.

export const TACTIC_ES = {
  "reconnaissance": "Reconocimiento",
  "resource-development": "Desarrollo de Recursos",
  "initial-access": "Acceso Inicial",
  "execution": "Ejecución",
  "persistence": "Persistencia",
  "privilege-escalation": "Escalada de Privilegios",
  "defense-evasion": "Evasión de Defensas",
  "credential-access": "Acceso a Credenciales",
  "discovery": "Descubrimiento",
  "lateral-movement": "Movimiento Lateral",
  "collection": "Recolección",
  "command-and-control": "Comando y Control",
  "exfiltration": "Exfiltración",
  "impact": "Impacto",
};

export const TACTIC_ORDER_ES = [
  ["reconnaissance", "Reconocimiento"],
  ["resource-development", "Desarrollo de Recursos"],
  ["initial-access", "Acceso Inicial"],
  ["execution", "Ejecución"],
  ["persistence", "Persistencia"],
  ["privilege-escalation", "Escalada de Privilegios"],
  ["defense-evasion", "Evasión de Defensas"],
  ["credential-access", "Acceso a Credenciales"],
  ["discovery", "Descubrimiento"],
  ["lateral-movement", "Movimiento Lateral"],
  ["collection", "Recolección"],
  ["command-and-control", "Comando y Control"],
  ["exfiltration", "Exfiltración"],
  ["impact", "Impacto"],
];

export const TECHNIQUE_ES = {
  "T1005": "Datos del Sistema Local",
  "T1027": "Archivos o Información Ofuscados",
  "T1046": "Descubrimiento de Servicios de Red",
  "T1059": "Intérprete de Comandos y Scripts",
  "T1059.007": "JavaScript",
  "T1068": "Explotación para Escalada de Privilegios",
  "T1078": "Cuentas Válidas",
  "T1078.001": "Cuentas por Defecto",
  "T1083": "Descubrimiento de Archivos y Directorios",
  "T1105": "Transferencia de Herramientas al Entorno",
  "T1110": "Fuerza Bruta",
  "T1189": "Compromiso por Navegación (Drive-by)",
  "T1190": "Explotación de Aplicación Expuesta a Internet",
  "T1203": "Explotación para Ejecución en el Cliente",
  "T1204": "Ejecución por el Usuario",
  "T1204.001": "Enlace Malicioso",
  "T1213": "Datos desde Repositorios de Información",
  "T1222": "Modificación de Permisos de Archivos y Directorios",
  "T1499": "Denegación de Servicio en el Endpoint",
  "T1548": "Abuso del Mecanismo de Control de Elevación",
  "T1552": "Credenciales sin Proteger",
  "T1562": "Degradación de Defensas",
  "T1593": "Búsqueda en Sitios y Dominios Abiertos",
  "T1566": "Phishing",
  "T1587": "Desarrollo de Capacidades",
};

export const ATLAS_TECHNIQUE_ES = {
  "AML.T0024.000": "Inferencia de Pertenencia a Datos de Entrenamiento",
  "AML.T0029": "Denegación del Servicio de IA",
  "AML.T0051": "Inyección de Prompt en LLM",
  "AML.T0051.000": "Inyección Directa de Prompt",
  "AML.T0053": "Invocación de Herramientas por el Agente de IA",
  "AML.T0054": "Evasión de Restricciones del LLM (Jailbreak)",
  "AML.T0055": "Credenciales sin Proteger",
  "AML.T0056": "Extracción del Prompt de Sistema del LLM",
  "AML.T0057": "Fuga de Datos del LLM",
  "AML.T0068": "Ofuscación del Prompt del LLM",
  "AML.T0003": "Investigación de la Víctima / Búsqueda en Fuentes Abiertas",
  "AML.T0043": "Elaboración de Datos Adversarios",
  "AML.T0052": "Phishing",
};

export const ATLAS_TACTIC_ES = {
  "Initial Access": "Acceso Inicial",
  "Defense Evasion": "Evasión de Defensas",
  "Exfiltration": "Exfiltración",
  "Privilege Escalation": "Escalada de Privilegios",
  "Impact": "Impacto",
  "Credential Access": "Acceso a Credenciales",
  "Reconnaissance": "Reconocimiento",
  "Persistence": "Persistencia",
  "Discovery": "Descubrimiento",
  "Collection": "Recolección",
  "Execution": "Ejecución",
  "ML Attack Staging": "Preparación del Ataque de ML",
  "ML Model Access": "Acceso al Modelo de ML",
  "Resource Development": "Desarrollo de Recursos",
  "AI Attack Staging": "Preparación del Ataque de IA",
};

export const OWASP_LLM_ES = {
  "Prompt Injection": "Inyección de Prompt",
  "Sensitive Information Disclosure": "Divulgación de Información Sensible",
  "Supply Chain": "Cadena de Suministro",
  "Data and Model Poisoning": "Envenenamiento de Datos y del Modelo",
  "Improper Output Handling": "Manejo Inadecuado de la Salida",
  "Excessive Agency": "Autonomía Excesiva",
  "System Prompt Leakage": "Fuga del Prompt de Sistema",
  "Vector and Embedding Weaknesses": "Debilidades de Vectores y Embeddings",
  "Misinformation": "Desinformación",
  "Unbounded Consumption": "Consumo sin Límites",
  "Broken Access Control": "Control de Acceso Roto",
  "Cryptographic Failures": "Fallas Criptográficas",
  "Injection": "Inyección",
  "Insecure Design": "Diseño Inseguro",
  "Security Misconfiguration": "Configuración de Seguridad Incorrecta",
  "Vulnerable and Outdated Components": "Componentes Vulnerables y Obsoletos",
  "Identification and Authentication Failures": "Fallas de Identificación y Autenticación",
  "Software and Data Integrity Failures": "Fallas de Integridad de Software y Datos",
  "Security Logging and Monitoring Failures": "Fallas de Registro y Monitoreo de Seguridad",
  "Server-Side Request Forgery": "Falsificación de Peticiones del Lado del Servidor (SSRF)",
};

export const CATEGORY_ES = {
  "ai_authentication": "Autenticación de IA",
  "ai_defense": "Defensa de IA",
  "ai_osint": "OSINT de IA",
  "ai_phishing": "Phishing con IA",
  "auth_bypass": "Evasión de Autenticación",
  "broken_authentication": "Autenticación Deficiente",
  "config_password_policy": "Configuración de Política de Contraseñas",
  "config_service_hardening": "Endurecimiento de Servicios",
  "configuration": "Configuración",
  "cors_misconfiguration": "Configuración Incorrecta de CORS",
  "data_leakage": "Fuga de Datos",
  "dependencies": "Dependencias",
  "encryption": "Cifrado",
  "function_abuse": "Abuso de Funciones",
  "general": "General",
  "infrastructure_file_sharing": "Compartición de Archivos en la Infraestructura",
  "jailbreaking": "Evasión de Restricciones (Jailbreak)",
  "network_discovery": "Descubrimiento de Red",
  "network_exposure": "Exposición de Red",
  "prompt_injection": "Inyección de Prompt",
  "prompt_injection_unicode": "Inyección de Prompt con Unicode",
  "rate_limiting": "Límite de Tasa de Peticiones",
  "resource_consumption": "Consumo de Recursos",
  "security_misconfiguration": "Configuración de Seguridad Incorrecta",
  "training_data_exposure": "Exposición de Datos de Entrenamiento",
  "web_configuration": "Configuración Web",
  "web_csrf": "CSRF Web",
};

export const categoryEs = (cat) => {
  const key = String(cat || "general").trim().toLowerCase();
  return CATEGORY_ES[key] || key.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
};

const ID_NAME = /^\s*([A-Za-z0-9.:]+)\s*[-–]\s*(.+?)\s*$/;
const TACTIC_WITH_ID = /^\s*(.+?)\s*\(([^)]+)\)\s*$/;

export const tacticEs = (value) => {
  if (!value) return "";
  const slug = String(value).trim().toLowerCase().replace(/\s+/g, "-").replace(/&/g, "and");
  return TACTIC_ES[slug] || ATLAS_TACTIC_ES[String(value).trim()] || value;
};

export const tacticsEs = (values) => (values || []).map(tacticEs).join(", ");

export const techniqueEs = (mitreId, name) => TECHNIQUE_ES[String(mitreId || "").trim()] || name || "";

export const attackRefEs = (value) => {
  if (!value) return "";
  const m = ID_NAME.exec(value);
  if (!m) return value;
  return `${m[1]} - ${TECHNIQUE_ES[m[1]] || m[2]}`;
};

export const ATLAS_NAME_ES = {
  "Victim Research / Search Open Sources": "Investigación de la Víctima / Búsqueda en Fuentes Abiertas",
  "Craft Adversarial Data": "Elaboración de Datos Adversarios",
  "Denial of AI Service": "Denegación del Servicio de IA",
  "Direct Prompt Injection": "Inyección Directa de Prompt",
  "Infer Training Data Membership": "Inferencia de Pertenencia a Datos de Entrenamiento",
  "AI Agent Tool Invocation": "Invocación de Herramientas por el Agente de IA",
  "LLM Jailbreak": "Evasión de Restricciones del LLM (Jailbreak)",
  "Unsecured Credentials": "Credenciales sin Proteger",
  "LLM Data Leakage": "Fuga de Datos del LLM",
  "LLM Prompt Obfuscation": "Ofuscación del Prompt del LLM",
  "Extract LLM System Prompt": "Extracción del Prompt de Sistema del LLM",
  "LLM Prompt Injection": "Inyección de Prompt en LLM",
};

export const atlasTechniqueEs = (atlasId, name) =>
  ATLAS_TECHNIQUE_ES[String(atlasId || "").trim()]
  || ATLAS_NAME_ES[String(name || "").trim()]
  || name || "";

export const atlasTacticEs = (value) => {
  if (!value) return "";
  const m = TACTIC_WITH_ID.exec(value);
  if (m) return `${ATLAS_TACTIC_ES[m[1]] || m[1]} (${m[2]})`;
  return ATLAS_TACTIC_ES[String(value).trim()] || value;
};

export const owaspLlmEs = (value) => {
  if (!value) return "";
  const m = ID_NAME.exec(value);
  if (!m) return OWASP_LLM_ES[String(value).trim()] || value;
  return `${m[1]} - ${OWASP_LLM_ES[m[2]] || m[2]}`;
};
